import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo_chico.png'
import _imports_1 from '@/assets/ar.svg'
import _imports_2 from '@/assets/us.svg'


const _hoisted_1 = { class: "h-screen flex items-center justify-center" }
const _hoisted_2 = { class: "container mx-auto w-full md:w-8/12 lg:w-6/12 p-5 bg-white bg-opacity-90 rounded-lg shadow-2xl space-y-2 text-center" }
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_7 = { class: "w-full px-2" }
const _hoisted_8 = { class: "block mb-1" }
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "flex flex-wrap items-center pt-3" }
const _hoisted_11 = { class: "font-bold text-red-500 w-full text-center" }
const _hoisted_12 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_13 = { class: "w-full px-2" }
const _hoisted_14 = { class: "block mb-1 text-center" }
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_17 = { class: "w-full px-2" }
const _hoisted_18 = { class: "flex flex-wrap space-y-4 md:space-y-0 pt-1 pb-5 items-center justify-center" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_21 = { class: "pi pi-check mr-2" }
const _hoisted_22 = { class: "flex flex-col lg:flex-row space-x-0 lg:space-x-2 space-y-2 lg:space-y-0 pt-5 items-center justify-center" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_26 = { class: "pi pi-check mr-2" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "flex items-center gap-2 pt-3 my-4 justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_RecuperarPasswordView = _resolveComponent("RecuperarPasswordView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onFormSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700 mx-5 -my-16 md:-my-36 lg:-my-24"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[11] || (_cache[11] = _createElementVNode("img", {
              src: _imports_0,
              class: "mx-auto"
            }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('titulo.login')), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('subtitulo.login')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('label.documento')), 1),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.documento')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('label.dni.existe')), 1)
            ], 512), [
              [_vShow, _ctx.pedirClaveActualizacion]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('label.clave.actualizacion')), 1),
                _createVNode(_component_Field, {
                  name: "claveActualizacion",
                  modelValue: _ctx.formData.claveActualizacion,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.claveActualizacion) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "password",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.clave.actualizacion')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "claveActualizacion" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 512), [
              [_vShow, _ctx.pedirClaveActualizacion]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mostrarDialogRecuperarPassword && _ctx.mostrarDialogRecuperarPassword(...args))),
                  type: "button"
                }, _toDisplayString(_ctx.$t('label.olvide.mi.clave')), 1)
              ])
            ], 512), [
              [_vShow, _ctx.pedirClaveActualizacion]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "submit",
                class: "w-full lg:w-auto px-4 py-2 cursor-pointer border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_20, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_21, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.validar.documento')), 1)
              ], 8, _hoisted_19)
            ], 512), [
              [_vShow, !_ctx.pedirClaveActualizacion]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              (_ctx.acreditado && _ctx.acreditado.estadoAcreditado?.id == 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.verCredencial && _ctx.verCredencial(...args))),
                    class: "w-full lg:w-auto px-4 py-2 bg-transparent border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl",
                    disabled: _ctx.isSubmitting
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("i", { class: "pi pi-arrow-circle-down mr-2" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('global.ver.credencial')), 1)
                  ], 8, _hoisted_23))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "submit",
                class: "w-full lg:w-auto px-4 py-2 bg-transparent border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_25, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_26, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.modificar.datos')), 1)
              ], 8, _hoisted_24),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelarAuth && _ctx.cancelarAuth(...args))),
                type: "button",
                class: "w-full lg:w-auto px-4 py-2 bg-transparent border-red-600 hover:bg-red-600 text-red-600 font-semibold hover:text-white border rounded-xl",
                disabled: _ctx.isSubmitting
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar')), 1)
              ], 8, _hoisted_27)
            ], 512), [
              [_vShow, _ctx.pedirClaveActualizacion]
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeLanguage('es'))),
                class: "hover:opacity-70 transition"
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "h-8"
                }, null, -1)
              ]))]),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeLanguage('en'))),
                class: "hover:opacity-70 transition"
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-8"
                }, null, -1)
              ]))])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"]),
    _createVNode(_component_BlockUI, { blocked: _ctx.isSubmitting }, null, 8, ["blocked"]),
    (_ctx.recuperarPasswordVisible)
      ? (_openBlock(), _createBlock(_component_RecuperarPasswordView, {
          key: 0,
          closeFunction: _ctx.cerrarDialogoRecuperarPassword,
          acreditado: _ctx.acreditado
        }, null, 8, ["closeFunction", "acreditado"]))
      : _createCommentVNode("", true)
  ], 64))
}